import { Provider } from '@angular/core';
import { CartInteractionCoordinator } from './cart-interaction.contracts';
import { CartInteractionCoordinatorService } from './cart-interaction-coordinator.service';

export * from './cart.service';
export * from './cart-interaction.contracts';
export * from './cart-interaction-coordinator.service';

/**
 * Binds the abstract {@link CartInteractionCoordinator} token to its concrete implementation (DIP).
 * Register once in the root providers so consumers can inject the abstraction. Swapping the
 * implementation later (e.g. a signals-based one) is a one-line change here.
 */
export const CART_INTERACTION_COORDINATOR_PROVIDER: Provider = {
  provide: CartInteractionCoordinator,
  useExisting: CartInteractionCoordinatorService,
};
